import { ResponseListRedesign } from './ResponseListRedesign';

export function ResponseListWrapper() {
	return (
		<div className="mb-16">
			<ResponseListRedesign />
		</div>
	);
}
